<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="headerPage">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 d-flex contentHeader">
            <div class="inputGroup col-lg-6" v-if="!id">
              <span>Selecione uma máquina:</span>
              <multiselect
                v-model="machineSelected"
                :options="machines"
                track-by="id"
                label="name"
                placeholder="Pesquisar Máquinas"
                :searchable="true"
                :allow-empty="true"
                :clear-on-select="false"
                :close-on-select="true"
                @input="openModal('confirm-modal')"
              >
              </multiselect>
            </div>
            <small v-if="!id">{{ machines.length }} máquinas cadastradas</small>
          </div>
          <div
            class="col-12 d-flex contentHeaderRight"
            v-if="hazard_analysis.id"
          >
            <!-- <div class="icon">
              <a :href="getExportUrl()" target="_blank">
                <font-awesome-icon style="color: white" icon="print" />
              </a>
            </div>-->
            <PdfExportProgress
              v-if="exportingPdf"
              :state="exportCurrentState"
              :progress="exportProgress"
              :status="exportStatus"
              :expected-completion-at="exportExpectedCompletionAt"
            />
            <b-dropdown v-else text="Exportar" class="m-md-2">
              <b-dropdown-item-button @click="exportPdf">
                PDF
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="confirm-modal"
      title="Nova APR"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="openModal('number-code-modal')"
    >
      Deseja criar uma APR para a máquina: {{ machineSelected.name }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
    <b-modal
      ref="number-code-modal"
      title="Nova APR"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="createAPR"
    >
      <input
        type="text"
        v-model="number_code"
        placeholder="Número do documento"
        ref="numbe_code_ref"
        class="form-control"
        disabled
      />
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>

    <b-modal
      ref="copy-modal"
      title="Copiar dados da APR"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="copyApr(aprSelectedToCopy.id)"
    >
      Deseja copiar os dados da APR {{ aprSelectedToCopy && aprSelectedToCopy.name }} para a nova APR?
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>

    <b-modal
      ref="number-code-modal"
      title="Nova APR"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="createAPR"
    >
      <input
        type="text"
        v-model="number_code"
        placeholder="Número do documento"
        ref="numbe_code_ref"
        class="form-control"
        disabled
      />
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
    <div class="container-fluid" v-if="isMachineSelected">
      <div class="form-group col-md-4 mt-2">
          <label>
            Responsável Técnico
            <span>*</span>
          </label>
          <multiselect
            v-model="selectedResponsibles"
            :options="technicalResponsibles"
            track-by="id"
            label="technical_responsible_name"
            placeholder="Selecione os Responsáveis Técnicos"
            :multiple="true"
            :clear-on-select="false"
            :close-on-select="false"
            :allow-empty="true"
            :hide-selected="true"
            :disabled="!canAccess()"
          >
          </multiselect>
      </div>
      <div class="row">
        <div class="col-12 navBarSection">
          <div
            class="navBarItem"
            v-bind:class="{ active: isSelectedSection('riscos') }"
            v-on:click="selectSection('riscos')"
          >
            <font-awesome-icon icon="suitcase" />
            <span>RISCOS</span>
          </div>

          <div
            class="navBarItem"
            v-bind:class="{ active: isSelectedSection('anexos') }"
            v-on:click="selectSection('anexos')"
            v-if="hazard_analysis.id"
          >
            <font-awesome-icon icon="paperclip" />
            <span>ANEXOS</span>
          </div>
        </div>
      </div>
      <div class="row risks" v-if="isSelectedSection('riscos')">
        <div class="col-12 machineDetails">
          <div class="col-12 p-0">
            <div class="titleMachine">
              <span>Visão Geral da Máquina:</span>
              <span class="textGray">
                <strong>&nbsp;{{ machineSelected.name }}</strong>
              </span>
            </div>
          </div>
          <!-- <div class="col-12">
            <b>Visão Geral</b>
          </div>-->
          <div class="col-12" style="margin-bottom: 25px">
            <div
              class="images d-flex justify-content-center align-items-center"
            >
              <img class="imgMachine image-rounded" :src="machineSelected.photo.url" alt />
            </div>
          </div>
          <div class="w-100 col-12">
            <Accordion>
              <template v-slot:title>
                <span style="font-size: 18px">Detalhes da Máquina</span>
              </template>
              <template v-slot:body>
                <div class="card-content col-12">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="textGray">Setor</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.sector"
                          name="sector"
                          v-bind:class="{
                            'input-error': showMachineError('sector'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('sector')"
                        >
                          O campo Setor é necessário.
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="textGray">Tipo</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.type"
                          name="type"
                          v-bind:class="{
                            'input-error': showMachineError('type'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('type')"
                        >
                          O campo Tipo é necessário.
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="textGray"
                          >Capacidade da Máquina/Equipamento</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.capacity"
                          name="capacity"
                          v-bind:class="{
                            'input-error': showMachineError('capacity'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('capacity')"
                        >
                          O campo Capacidade é necessário.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="textGray">Marca</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.manufacturer"
                          name="manufacturer"
                          v-bind:class="{
                            'input-error': showMachineError('manufacturer'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('manufacturer')"
                        >
                          O campo Fabricante é necessário.
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="textGray">Ano de Fabricação</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.manufactured_at"
                          name="manufactured_at"
                          v-mask="'####'"
                          v-bind:class="{
                            'input-error': showMachineError('manufactured_at'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('manufactured_at')"
                        >
                          O campo Ano de Fabricação é necessário.
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="textGray">Tensão Elétrica</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.tension"
                          name="tension"
                          v-bind:class="{
                            'input-error': showMachineError('tension'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('tension')"
                        >
                          O campo Tensão é necessário.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="textGray">Número de Série</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.serie_number"
                          name="serie_number"
                          v-bind:class="{
                            'input-error': showMachineError('serie_number'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('serie_number')"
                        >
                          O campo Número de Série é necessário.
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="textGray">Função da Máquina</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="machineSelected.machine_function"
                          name="machine_function"
                          v-bind:class="{
                            'input-error': showMachineError('machine_function'),
                          }"
                          :disabled="!canAccess()"
                        />
                        <div
                          class="general-error"
                          v-if="showMachineError('machine_function')"
                        >
                          O campo Função da Máquina é necessário.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="observations">Observações</label>
                        <textarea
                          v-model="machineSelected.observations"
                          class="form-control"
                          name="observations"
                          v-bind:class="{
                            'input-error': showMachineError('observations'),
                          }"
                          :disabled="!canAccess()"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" style="padding: 2vh 2vw">
                      <button 
                        class="btn btn-success float-right" 
                        v-on:click="updateMachine()"
                        v-if="canAccess()"
                        >
                        <span>
                          Salvar Máquina  
                          <font-awesome-icon icon="save" /> 
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <b-alert 
                        v-show="machineSuccess" 
                        variant="success" 
                        show
                        dismissible
                        :fade="true"
                        style="font-size: 1.1rem; font-weight: 500;"
                      >
                        <font-awesome-icon icon="check-circle" class="mr-2" />
                        Máquina atualizada com sucesso!
                      </b-alert>
                    </div>
                  </div>
                </div>
              </template>
            </Accordion>
          </div>
        </div>
        <div class="col-12 machineDetails pb-4">
          <div class="col-12 titleMachine d-flex items-center justify-between">
            <h5 class="col-4">Determinação dos Limites da Máquina/Equipamento</h5>
            <multiselect
              class="col-3"
              v-model="selectedUnit"
              :options="companiesList"
              track-by="id"
              label="name"
              placeholder="Selecionar Unidade"
              :searchable="true"
              :allow-empty="true"
              :clear-on-select="false"
              :close-on-select="true"
              @input="handleUnitSelected"
              v-if="(!art_id || hazard_analysis.hazards.length <= 0) && canAccess()"
            />
            <multiselect
              class="col-3"
              v-model="selectedMachine"
              :options="machinesList"
              track-by="id"
              label="name"
              placeholder="Pesquisar Máquina"
              :searchable="true"
              :allow-empty="true"
              :clear-on-select="false"
              :close-on-select="true"
              :disabled="!selectedUnit"
              v-if="(!art_id || hazard_analysis.hazards.length <= 0) && canAccess()"
            />
            <button 
              class="btn btn-success float-right" 
              v-on:click="copyApr()"
              :disabled="!selectedUnit || !selectedMachine"
              v-if="(!art_id || hazard_analysis.hazards.length <= 0) && canAccess()"
            >
              <span>
                Copiar APR
              </span>
            </button>
          </div>
          <div class="" style="display: flex; flexDirection: row;">
            <div class="form-group col-4">
              <label>Número APR</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="number_code"
                  maxlength="191"
                  disabled
                />
              </div>
            </div>
            <div class="form-group col-4">
              <label>Número ART</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="art_number"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-4">
              <div class="form-group">
                <label>Abastecimento</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.art.supply"
                  :disabled="!canAccess()"
                  default=""
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Manual">Manual</option>
                  <option value="Automático">Automático</option>
                  <option value="Automático e Manual">
                    Automático e Manual
                  </option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Ciclo de operação</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.art.operation_cycle"
                  :disabled="!canAccess()"
                  default=""
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Manual">Manual</option>
                  <option value="Automático">Automático</option>
                  <option value="Semiautomático">Semiautomático</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Elementos Motrizes</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.art.motive_power"
                  :disabled="!canAccess()"
                  default=""
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Elétricos">Elétricos</option>
                  <option value="Hidráulicos">Hidráulicos</option>
                  <option value="Pneumáticos">Pneumáticos</option>
                  <option value="Elétricos/Pneumáticos">
                    Elétricos/Pneumáticos
                  </option>
                  <option value="Elétricos/Hidráulicos">
                    Elétricos/Hidráulicos
                  </option>
                  <option value="Elétricos/Pneumáticos/Hidráulicos">
                    Elétricos/Pneumáticos/Hidráulicos
                  </option>
                  <option value="CombustãoInterna">
                    Combustão Interna
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-4">
              <div class="form-group">
                <label>Paradas de Movimentos</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.art.mechanical_stop"
                  :disabled="!canAccess()"
                  default=""
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Inercial">Inercial</option>
                  <option value="Não Inercial">Não Inercial</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Função da Máquina</label>
                <input type="text" class="form-control" v-model="hazard_analysis.art.machine_function" maxlength="191" :disabled="!canAccess()" />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Histórico de Acidentes/Incidentes</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.has_history_accidents"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>
          <div class="col-12" v-if="canAccess()">
            <h5>Documentação da Máquina/Equipamento:</h5>
          </div>
          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2"
                >Operadores: Treinamento Operacional para o tipo de
                máquina/equipamento:</label
              >
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="operator_training_yes"
                  name="operator_has_operational_training"
                  :value="true"
                  v-model="hazard_analysis.art.operator_has_operational_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="operator_training_yes">Sim</label>
              </div>

              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="operator_training_no"
                  name="operator_has_operational_training"
                  :value="false"
                  v-model="hazard_analysis.art.operator_has_operational_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="operator_training_no">Não</label>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="
                    hazard_analysis.art
                      .operator_has_operational_training_description
                  "
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2">
                Operadores: Treinamento de Segurança para máquina/equipamento:
              </label>
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="operator_has_safety_training_yes"
                  name="operator_has_safety_training"
                  :value="true"
                  v-model="hazard_analysis.art.operator_has_safety_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="operator_has_safety_training_yes">Sim</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="operator_has_safety_training_no"
                  name="operator_has_safety_training"
                  :value="false"
                  v-model="hazard_analysis.art.operator_has_safety_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="operator_has_safety_training_no">Não</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.operator_has_safety_training_description"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>

          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2">Manual da Máquina/Equipamento:</label>
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_manual_yes"
                  name="has_manual"
                  :value="true"
                  v-model="hazard_analysis.art.has_manual"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_manual_yes">Sim</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_manual_no"
                  name="has_manual"
                  :value="false"
                  v-model="hazard_analysis.art.has_manual"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_manual_no">Não</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.has_manual_description"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>

          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2">Laudo de aterramento:</label>
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_grounding_report_yes"
                  name="has_grounding_report"
                  :value="true"
                  v-model="hazard_analysis.art.has_grounding_report"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_grounding_report_yes">Sim</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_grounding_report_no"
                  name="has_grounding_report"
                  :value="false"
                  v-model="hazard_analysis.art.has_grounding_report"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_grounding_report_no">Não</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.has_grounding_report_description"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>

          <div class="col-12" v-if="edit_permission">
            <h5>Documentação da Máquina/Equipamento: Manutenção</h5>
          </div>

          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2">Abertura de Ordem de Serviço:</label>
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_opening_service_order_yes"
                  name="has_opening_service_order"
                  :value="true"
                  v-model="hazard_analysis.art.has_opening_service_order"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_opening_service_order_yes">Sim</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_opening_service_order_no"
                  name="has_opening_service_order"
                  :value="false"
                  v-model="hazard_analysis.art.has_opening_service_order"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_opening_service_order_no">Não</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.has_opening_service_order_description"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>

          <div class="row p-3">
            <div class="col-4">
              <label class="mr-2">Treinamento Manutentores:</label>
            </div>
            <div class="col-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_maintenance_training_yes"
                  name="has_maintenance_training"
                  :value="true"
                  v-model="hazard_analysis.art.has_maintenance_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_maintenance_training_yes">Sim</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input big-radio"
                  type="radio"
                  id="has_maintenance_training_no"
                  name="has_maintenance_training"
                  :value="false"
                  v-model="hazard_analysis.art.has_maintenance_training"
                  :disabled="!canAccess()"
                />
                <label class="form-check-label" for="has_maintenance_training_no">Não</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Observações</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.art.has_maintenance_training_description"
                  maxlength="191"
                  :disabled="!canAccess()"
                />
              </div>
            </div>
          </div>
          </div>

        <div class="col-12 machineDetails pb-4">
          <div class="col-12 titleMachine">
            <h5>Identificação de categoria para sistemas de segurança</h5>
          </div>
          <div class="row p-3">
            <div class="col-4">
              <div class="form-group">
                <label>S</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.security_system_identification.s"
                  :disabled="!canAccess()"
                >
                  <option value="">Selecione uma opção</option>
                  <option value="S1">S1</option>
                  <option value="S2">S2</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>F</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.security_system_identification.f"
                  :disabled="
                    hazard_analysis.security_system_identification.s == 'S1' ||
                    hazard_analysis.security_system_identification.s ==
                      undefined || hazard_analysis.security_system_identification.s == '' || !canAccess()
                  "
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="F1">F1</option>
                  <option value="F2">F2</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>P</label>
                <select
                  class="form-control"
                  v-model="hazard_analysis.security_system_identification.p"
                  :disabled="
                    hazard_analysis.security_system_identification.s == 'S1' ||
                    hazard_analysis.security_system_identification.f ==
                      undefined || hazard_analysis.security_system_identification.s == '' || !canAccess()
                  "
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="P1">P1</option>
                  <option value="P2">P2</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-12" style="text-align: center">
              <span v-if="security_system_category != ''" class="result">
                Resultado:
                <strong>Categoria {{ security_system_category }}</strong>
              </span>
            </div>
          </div>
          <div class="row p-3">
            <div class="col-12">
              <div class="form-group">
                <label>
                  Fatores Relevantes
                  <span class="error">*</span>
                </label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="hazard_analysis.factors"
                  rows="4"
                  :disabled="!canAccess()"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 machineDetails pb-4">
          <div class="col-12 titleMachine">
            <h5>Riscos Identificados</h5>
          </div>
          <div v-if="render" class="w-100">
            <div
              v-for="(risk, index) in hazard_analysis.hazards"
              v-bind:key="index"
              class="col-12 risk"
              ref="hazardList"
            >
              <Accordion>
                <template v-slot:title>
                  <span :class="'risk-color'" style="font-size: 18px;">
                    {{ risk.name }}
                    <button
                      class="btn btn-danger"
                      type="button"
                      style="background-color:transparent;color:red;border:none;padding-top:0px;padding-bottom:0px"
                      v-on:click="openModalHazardToDelete(risk)"
                      v-if="canAccess()"
                    > 
                      <font-awesome-icon icon="trash" style="font-size:12px" />
                    </button>
                  </span>
                </template>
                <template v-slot:body>
                  <Hazard
                    :hazard_analysis_id="hazard_analysis.id"
                    :data="risk"
                    :hazardDescriptions="hazardDescriptions"
                    :readonly="!edit_permission"
                    :hazardIndex="index"
                    :machine_id="hazard_analysis.machine.id"
                    :extras="extraFieldsApr"
                    @save="(e)=> onSaveHazard(e, index)"
                    @pushHazard="onPushHazard"
                    ref="hazard"
                  ></Hazard>
                </template>
              </Accordion>
            </div>
          </div>
          <div class="col-12" style="padding: 2vh 2vw" v-if="canAccess()">
            <button
              class="btn btn-primary float-right"
              v-on:click="newRisk()"
            >
              <span>Novo Risco  <font-awesome-icon icon="plus" /> </span>
            </button>
          </div>
        </div>
        <div class="col-12"></div>
        <div class="col-12" style="padding: 2vh 2vw" v-if="edit_permission">
          <button class="btn btn-success float-right" v-on:click="saveART()">
            <span>Salvar Documento  <font-awesome-icon icon="save" /> </span>
          </button>
        </div>
        <div class="col-12">
          <b-alert 
            v-show="success" 
            variant="success" 
            show
            dismissible
            :fade="true"
            style="font-size: 1.1rem; font-weight: 500;"
          >
            APR salva com sucesso! Redirecionando...
          </b-alert>
          <b-alert
            dismissible
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            fade
            :show="dismissCountDown"
            variant="warning"
            >Ocorreu um erro ao salvar os riscos da APR, verifique se você
            preencheu todos os campos obrigatórios corretamente</b-alert
          >
        </div>
        <div class="alertError" style="width: 100%; height: 50px"></div>
      </div>

      <div class="row attachments" v-if="isSelectedSection('anexos')">
        <div class="col-8" v-if="localCompanyId && id">
          <AttachmentsList
            :company_id="localCompanyId"
            :machine_id="hazard_analysis.machine.id"
            typeDocument="hazard_analysis"
            :document_id="id"
            :readonly="!edit_permission"
          ></AttachmentsList>
        </div>
      </div>
    </div>

    <b-modal
      ref="hazard-confirm-modal"
      title="Remover Ação"
      modal-ok="Confirmar"
      modal-cancel="Cancelar"
      @ok="removeHazard()"
    >
        Deseja remover o 
      {{ hazardToDelete ? hazardToDelete.name : '' }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import Accordion from "@/components/Accordion.vue";
import AttachmentsList from "@/components/AttachmentsList.vue";
import Hazard from "@/components/Hazard.vue";
import PdfExportProgress from "@/components/PdfExportProgress.vue";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "APR",
  components: {
    Accordion,
    Hazard,
    AttachmentsList,
    PdfExportProgress,
    Multiselect
  },
  data() {
    return {
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      extraFieldsApr: localStorage.getItem('extras') || 'false',
      hazard: {},
      hazard_analysis: { art: {}, security_system_identification: {} },
      hazardDescriptions: [],
      machines: [],
      hazardAnalysisList: [],
      companiesList: [],
      machinesList: [],
      selectedMachine: null,
      selectedUnit: null,
      machineSelected: "0",
      machineSuccess: false,
      number_code: "",
      art_number: "",
      art_id: null,
      isMachineSelected: false,
      selectedSection: "riscos",
      company: {},
      risks: [],
      render: false,
      exportUrl: "",
      exportingPdf: false,
      exportCurrentState: "",
      exportProgress: 0,
      exportStatus: "pending",
      exportExpectedCompletionAt: null,
      componentDestroyed: false,
      success: false,
      security_system_category: "",
      registersStack: [],
      dismissSecs: 8,
      dismissCountDown: 0,
      lastHazardNumberName: "",
      technicalResponsibles: [],
      selectedResponsibles: [],
      aprSelectedToCopy: null,
      securityData: null,
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "APR's",
          href: `#/admin/Documents/ListDocuments/${this.company_id || localStorage.getItem('company_id')}/APR`,
        },
        {
          text: "APR",
          active: true,
        },
      ],
      role: localStorage.getItem("auth.role"),
      edit_permission: this.role != "client" || !this.id,
      hazardToDelete: null,
    };
  },
  props: {
    id: String,
    company_id: String,
  },
  mounted: async function () {
    const loader = this.$loading.show();
    this.edit_permission = this.role != "client" || !this.id;

    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }

    this.lastHazardNumberName =
    localStorage.getItem("extra_fields_apr") == 1 ? 12 : 11;
    
    await this.getTechnicalResponsibles();
    await this.getMachinesByCompanyId();
    
    if (this.id) {
      await this.getAPR();
      await this.getCompaniesList();
      // await this.getAprsList();
    } else {
      await this.generateNumberCode();
    }
    await this.getHazardsDescriptions();
    
    loader.hide();
  },
  methods: {
    canAccess,
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
          this.extraFieldsApr = response.data.data.extra_fields_apr ? 'true' : 'false';
        });
    },
    copyApr: async function () {
      if (!this.selectedMachine.hazardId|| !this.hazard_analysis.id) {
        console.error("APR de origem ou apr de destino não selecionada.");
        return;
      }

      const originId = this.selectedMachine.hazardId;
      const destinationId = this.hazard_analysis.id

      try {
        const loader = this.$loading.show();
        await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses/${originId}/copy/${destinationId}`
        );
        loader.hide();
        await this.getAPR();
      } catch (error) {
        console.error("Erro ao copiar APR:", error.response?.data || error);
      }
    },
    getCompaniesList:async function(){
      try {
        await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies`,
          {
            params: {
              not_paginated: true,
            },
          }
        ).then((response) => {
          const sanitizedCompanies = response.data.data.map((company)=>{
            return {
              name : `${company.corporate_name} ${company.parent_company ? '- ' + company.parent_company.corporate_name : ''}`,
              id: company.id
            }
          });
          this.companiesList = sanitizedCompanies;
        });
      } catch (error) {
        console.error("Error fetching Units list:", error);
      }
    },
    async handleUnitSelected(unit) {
      this.selectedMachine = null;
      this.machinesList = [];

      if (!unit) return;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines?company_id=${unit.id}&include=hazardAnalyses`,
          {
            params: {
              not_paginated: true,
            },
          }
        );

        // Para cada máquina, cria uma entrada para cada hazard_analyses existente
        this.machinesList = response.data.data
          .filter(machine => machine.hazard_analyses && machine.hazard_analyses.length > 0)
          .flatMap(machine =>
            machine.hazard_analyses.map(hazard => ({
              machineId: machine.id,
              hazardId: hazard.id,
              name: `${hazard.number_code} - ${machine.name}`
            }))
          );
      } catch (error) {
        console.error("Erro ao buscar máquinas:", error);
        this.machinesList = [];
      }
    },

    // getAprsList: async function(){
    //   try {
    //     await axios.get(
    //       `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses`,
    //       {
    //         params: {
    //           include: 'machine.company',
    //           not_paginated: true,
    //         },
    //       }
    //     ).then((response) => {
    //       const sanitizedAprs = response.data.data.map((apr)=>{
    //         return {
    //           name : `${apr.number_code} - ${apr.machine ? apr.machine.name : ''} - ${apr.machine && apr.machine.company ? apr.machine.company.corporate_name : ''} - ${apr.machine && apr.machine.company.corporate_group ? apr.machine.company.corporate_group.name : ''} - ${this.formatDate(apr.executed_at)}`,
    //           id: apr.id
    //         }
    //       });
    //       this.hazardAnalysisList = sanitizedAprs;
    //     });
    //   } catch (error) {
    //     console.error("Error fetching APRs list:", error);
    //   }
    // },
    formatDate: function (date) {
      return moment(date).format("YYYY");
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onSaveHazard: function (hazardName, index) {
      const hazardElement = this.$refs.hazardList[index];
      this.registersStack = this.registersStack.filter(
        (el) => el != hazardName
      );
      setTimeout(() => {
        const activeAccordion = hazardElement.querySelector(".accordion.active .header");
        if (activeAccordion) {
          activeAccordion.click(); // Trigger the click event
        }
      }, 3000);
    },

    getTechnicalResponsibles: function(){
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/${this.localCompanyId}/technical-responsible`
        ).then((response)=>{
          this.technicalResponsibles= response.data;
        })
    },

    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines?company_id=${this.localCompanyId}`,
        {
          params: {
            reduced: true,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );
      this.machines = response.data.data;
    },
    
    onPushHazard: function (hazardName) {
      this.registersStack.push(hazardName);
    },
    generateHazardName: function () {
      return "Novo Risco";
    },
    selectSection: function (section) {
      this.selectedSection = section;
    },
    isSelectedSection: function (section) {
      return this.selectedSection == section;
    },
    generateNumberCode: async function () {
      await axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/admin/get-document-count-by-user/${localStorage.getItem(
            "auth.user_id"
          )}`
        )
        .then((response) => {
          let userCode = localStorage.getItem("auth.user_id").substring(0, 4);
          let date = moment().format("YY.MM.DD");
          this.number_code = `${date}.${userCode}.${response.data}`;
        });
    },

    newRisk: function () {
      this.render = false;
      if (!this.hazard_analysis.hazards) {
        this.hazard_analysis.hazards = [];
      }

      // if the last this.hazard_analysis.hazards has no id, it means that it is not saved yet
      if (
        this.hazard_analysis.hazards.length > 0 &&
        !this.hazard_analysis.hazards[this.hazard_analysis.hazards.length - 1].id
      ) {
        this.render = true;

        this.$bvToast.toast(
          "É necessário salvar o último risco antes de adicionar um novo.",
          {
            title: "Atenção",
            variant: "warning",
            autoHideDelay: 5000,
            appendToast: true,
          }
        );
        return;
      }

      this.hazard_analysis.hazards.push({
        name: this.generateHazardName(),
        photos: [],
      });
      this.registersStack.push(
        this.hazard_analysis.hazards[this.hazard_analysis.hazards.length - 1]
          .name
      );
      this.render = true;
    },

    showError: function (attribute) {
      return this.$v.hazard_analysis[attribute].$invalid && this.submited;
    },
    showMachineError: function (attribute) {
      return this.$v.machineSelected[attribute].$invalid && this.submited;
    },
    required: function (attribute) {
      return this.$v.hazard_analysis[attribute].$params.required;
    },
    openModal: function (modal) {
      this.$refs[modal].show();
    },
    confirmModal: function () {},

    createAPR: async function (modalEvent) {
      if (this.number_code) {
        const loader = this.$loading.show();
        this.isMachineSelected = true;
        if(this.number_code.length === 0){
          await this.generateNumberCode();
        }
        await axios
          .post(`${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses`, {
            number_code: this.number_code,
            art_number: this.art_number,
            machine_id: this.machineSelected.id,
            executed_at: moment().format("YYYY-MM-DD"),
            technical_responsivel: this.selectedResponsibles
          })
          .then(async (response) => {
            this.hazard_analysis = { art: {}, ...response.data };
            this.hazard_analysis.security_system_identification = {};
            this.id = this.hazard_analysis.id;
            await axios
              .post(
                `${process.env.VUE_APP_API_HOST}/api/admin/store-hazard-analyses-user`,
                {
                  user_id: localStorage.getItem("auth.user_id"),
                  hazard_analysis_id: this.id,
                }
              )
              .then((response) => {
                this.hazard_analysis = { art: {}, ...response.data };
                this.hazard_analysis.security_system_identification = {};
              })
              .catch(() => {
                this.warning = true;
              });
            await this.getCompaniesList();
          })
          .catch(() => {
            this.warning = true;
          })
          .finally(() => loader.hide());
      } else {
        modalEvent.preventDefault();
        this.$refs.numbe_code_ref.focus();
      }
    },
    saveART: async function () {
        const loader = this.$loading.show();

        const { s, f, p } = this.hazard_analysis.security_system_identification;

        // Regra: caso s, f ou p estejam vazios, envia null
        if (s === "") {
          this.securityData = null;
        } else {
          // Regra: se s for "S1", não enviar f e p
          if (s === "S1") {
            this.securityData = { s };
          } else if(s === "S2") {
            if(f === undefined || p === undefined){
              this.$bvToast.toast(
                "É necessário selecionar todas as categorias de segurança para continuar.",
                {
                  title: "Atenção",
                  variant: "warning",
                  autoHideDelay: 5000,
                  appendToast: true,
                }
              );
              loader.hide()
              return;
            }
            this.securityData = { s, f, p };
          }
        }
        await axios
          .post(`${process.env.VUE_APP_API_HOST}/api/admin/arts`, {
            ...this.hazard_analysis.art,
            number_code: this.number_code || "",
            machine_id: this.machineSelected.id,
          })
          .then((response) => {
            let art_id = response.data.id;
            this.updateAPR(art_id);
          })
          .catch(() => {
            this.warning = true;
          })
          .finally(() => (loader.hide()));
      
    },
    updateAPR: async function (art_id = null) {
      // if (this.registersStack.length > 0) {
      //   this.dismissCountDown = this.dismissSecs;
      // } else {
      const loader = this.$loading.show();
      if( this.$refs.hazard){
        this.$refs.hazard.forEach((el) => {
          el.save();
        });
      }

      await axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses/${this.id}`,
          {
            factors: this.hazard_analysis.factors,
            place: this.hazard_analysis.place,
            number_code: this.number_code,
            art_number: this.art_number,
            art_id: art_id,
            machine_id: this.machineSelected.id,
            technical_responsivel: this.selectedResponsibles,
            security_system_identification: this.securityData ? JSON.stringify(this.securityData) : null,
          }
        )
        .then((response) => {
          localStorage.setItem('apr_success_notification', 'true');
          
          setTimeout(() => {
            this.success = false;
            this.$router.push({
              name: 'ListDocuments',
              params: {
                company_id: this.localCompanyId,
                doctype: 'APR',
                docTypeText: 'APR\'s'
              }
            });
            //redirect
          }, 1500);
          return response.data;
        })
        .catch(() => {
          this.warning = true;
        })
        .finally(() => (loader.hide()));
      // }
    },
    getAPR: async function (hazardBeforeDelete = []) {
      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses/${this.id}`
        )
        .then((response) => {
          this.hazard_analysis = response.data;
          this.machineSelected = this.hazard_analysis.machine;
          this.selectedResponsibles = this.hazard_analysis.technicals;
          this.isMachineSelected = true;
          this.art_number = response.data.art_number,
          this.art_id = response.data.art_id,
          this.render = true;
          this.exportUrl = this.getExportUrl();
          this.hazard_analysis.art = this.hazard_analysis.art
            ? this.hazard_analysis.art
            : {};
          this.hazard_analysis.security_system_identification =
            JSON.parse(this.hazard_analysis.security_system_identification) ||
            {};
          this.number_code = this.hazard_analysis.number_code || '';
          // if there's any hazard before delete get the hazards that are not in the hazard analysis
          if (hazardBeforeDelete.length > 0) {
            let leftHazards = hazardBeforeDelete.filter((el) => {
              return !this.hazard_analysis.hazards.some(
                (el2) => el2.id == el.id
              );
            });

            if (leftHazards.length > 0) {
              leftHazards.forEach((el) => {
                this.hazard_analysis.hazards.push(el);
              });
            }
          }

          this.hazard_analysis.hazards.forEach(() =>
            this.generateHazardName()
          );
        });
    },
    getHazardsDescriptions: async function () {
      let filter = `filter[machine.company.id]=${this.localCompanyId}&include=machine.company,hazards`;

      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazard-analyses?` + filter
        )
        .then((response) => {
          let allCompanyHazardsAnalysis = response.data.data;

          this.hazardDescriptions = [];
          for (var i = 0; i < allCompanyHazardsAnalysis.length; i++) {
            for (
              var j = 0;
              j < allCompanyHazardsAnalysis[i].hazards.length;
              j++
            ) {
              let hazardDescription = {};
              hazardDescription.id = allCompanyHazardsAnalysis[i].hazards[j].id;
              hazardDescription.name =
                allCompanyHazardsAnalysis[i].hazards[j].name;
              hazardDescription.description =
                allCompanyHazardsAnalysis[i].hazards[j].description;
              hazardDescription.machine =
                allCompanyHazardsAnalysis[i].machine.name;
              this.hazardDescriptions.push(hazardDescription);
            }
          }
        });
    },
    getExportUrl: function () {
      return `${process.env.VUE_APP_API_HOST}/export-hazard-analysis/${this.hazard_analysis.id}.pdf`;
    },
    downloadGeneratedPdf(url) {
      // A resposta do S3 usa Content-Disposition: attachment. Este caminho não
      // depende da permissão de popup, que costuma ser perdida enquanto o front
      // aguarda a geração assíncrona terminar.
      window.location.assign(url);
    },
    /**
     * O PDF da APR passou a ser gerado em segundo plano: a requisição só
     * enfileira a geração e devolve por onde acompanhar o andamento.
     */
    async exportPdf() {
      if (this.exportingPdf) {
        return;
      }

      this.exportingPdf = true;
      this.exportCurrentState = "";
      this.exportProgress = 0;
      this.exportStatus = "pending";
      this.exportExpectedCompletionAt = null;

      let data;
      try {
        const response = await axios.get(this.getExportUrl());
        data = response.data;
      } catch (error) {
        this.exportingPdf = false;
        this.$bvToast?.toast(error.response?.data?.message || "Não foi possível gerar o PDF da APR.", {
          title: "Erro", variant: "danger", solid: true, toaster: "b-toaster-top-right",
        });
        return;
      }

      if (data.status === "completed" && data.download_url) {
        this.exportingPdf = false;
        this.downloadGeneratedPdf(data.download_url);
        return;
      }

      this.applyAprExportStatus(data);

      this.$bvToast?.toast("Gerando o PDF da APR em segundo plano. Você será avisado quando estiver pronto.", {
        title: "Exportação", variant: "info", solid: true, toaster: "b-toaster-top-right",
      });

      await this.pollExportStatus(data.status_url);
      this.exportingPdf = false;
    },
    async pollExportStatus(statusUrl) {
      if (!statusUrl) {
        return;
      }

      let pollDelay = this.exportStatus === "pending" ? 10000 : 3000;
      let consecutiveErrors = 0;

      while (!this.componentDestroyed) {
        await new Promise((resolve) => setTimeout(resolve, pollDelay));

        if (this.componentDestroyed) {
          return;
        }

        try {
          const { data } = await axios.get(statusUrl, { params: { _t: Date.now() } });
          consecutiveErrors = 0;
          this.applyAprExportStatus(data);
          pollDelay = data.status === "pending" ? 10000 : 3000;

          if (data.status === "completed" && data.download_url) {
            this.$bvToast?.toast("PDF da APR pronto para download.", {
              title: "Exportação", variant: "success", solid: true, toaster: "b-toaster-top-right",
            });
            this.downloadGeneratedPdf(data.download_url);
            return;
          }

          if (data.status === "failed") {
            this.$bvToast?.toast(data.error_message || "Falha ao gerar o PDF da APR.", {
              title: "Erro", variant: "danger", solid: true, toaster: "b-toaster-top-right",
            });
            return;
          }
        } catch (error) {
          consecutiveErrors += 1;
          pollDelay = 10000;
          if (consecutiveErrors >= 5) {
            this.$bvToast?.toast("Não foi possível consultar o status do PDF. Tente novamente.", {
              title: "Erro", variant: "danger", solid: true, toaster: "b-toaster-top-right",
            });
            return;
          }
        }
      }
    },
    applyAprExportStatus(data) {
      this.exportStatus = data.status || this.exportStatus;
      this.exportCurrentState = data.status === "pending"
        ? "Aguardando para começar..."
        : (data.current_state || "");
      this.exportProgress = data.progress_percentage || 0;
      this.exportExpectedCompletionAt = data.status === "processing"
        ? (data.expected_completion_at || null)
        : null;
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("alertError")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    updateMachine() {
      this.machineSuccess = false;
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines/` +
            this.machineSelected.id,
          {
            name: this.machineSelected.name,
            type: this.machineSelected.type,
            capacity: this.machineSelected.capacity,
            manufacturer: this.machineSelected.manufacturer,
            tension: this.machineSelected.tension,
            manufactured_at: this.machineSelected.manufactured_at,
            serie_number: this.machineSelected.serie_number,
            sector: this.machineSelected.sector,
            observations: this.machineSelected.observations,
            machine_function: this.machineSelected.machine_function,
          }
        )
        .then((response) => {
          this.$bvToast.toast('Máquina atualizada com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000,
            appendToast: false
          });
          
          this.machineSuccess = true;
          setTimeout(() => {
            this.machineSuccess = false;
            document.querySelector(".accordion.active").classList.remove('active');
          }, 2000);
          return response.data;
        })
        .catch(() => {
          this.warning = true;
        });
    },
    openModalHazardToDelete: function (item) {
      this.hazardToDelete = item;
      this.$refs['hazard-confirm-modal'].show();
    },
    removeHazard: async function () {
      if (this.hazardToDelete.id) {
        const loader = this.$loading.show();

        await axios
          .delete(
            `${process.env.VUE_APP_API_HOST}/api/admin/hazards/${this.hazardToDelete.id}`
          )
          .then(async () => {
            // Get all hazards from the hazard analysis before deleting
            let hazardBeforeDelete = this.hazard_analysis.hazards;
            hazardBeforeDelete = hazardBeforeDelete.filter(
              (el) => el.id != this.hazardToDelete.id
            );

            this.hazard_analysis.hazards = this.hazard_analysis.hazards.filter(
              (el) => el.id != this.hazardToDelete.id
            );
            (this.hazardToDelete = null), loader.hide();
            await this.getAPR(hazardBeforeDelete);
            
            this.$nextTick(() => {
              this.reorderAllImprovementActions();
            });
          })
          .catch(() => {
            loader.hide();
          });
      } else {
        this.hazard_analysis.hazards.pop();
        this.hazardToDelete = null;
        
        this.$nextTick(() => {
          this.reorderAllImprovementActions();
        });
      }

      if (this.hazard_analysis.hazards.length % 2 != 0) {
        this.lastHazardNumberName--;
      }
    },
    
    reorderAllImprovementActions() {
      if (this.$refs.hazard && this.$refs.hazard.length > 0) {
        this.$refs.hazard.forEach((hazardComponent) => {
          if (hazardComponent && typeof hazardComponent.reorderActions === 'function') {
            hazardComponent.reorderActions();
          }
        });
      }
    }
  },
  beforeDestroy() {
    // Interrompe o acompanhamento do PDF: sem isso o polling continuaria
    // rodando contra um componente que já saiu da tela.
    this.componentDestroyed = true;
  },
  beforeRouteLeave(to, from, next) {
  console.log("beforeRouteLeave");
    let canLeave = true;
    if (this.$refs.hazard) {
      this.$refs.hazard.forEach((el) => {
        if (el.alert_type == "warning") {
          this.dismissCountDown = this.dismissSecs;
          this.scrollToElement();
          canLeave = false;
          next(false);
        }
      });
      if (canLeave) {
        this.success = true;
        next();
      }
    } else {
      next();
    }
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
    "hazard_analysis.security_system_identification": {
      handler: function (security_system_identification) {
        // Limpar F e P quando S for "S1" ou ""
        if (security_system_identification.s == "S1" || security_system_identification.s == "") {
          if (security_system_identification.s == "S1") {
            this.security_system_category = "1";
          } else {
            this.security_system_category = "";
          }
          // Limpar os valores de F e P
          this.hazard_analysis.security_system_identification.f = "";
          this.hazard_analysis.security_system_identification.p = "";
        } else if (security_system_identification.s == "S2") {
          this.security_system_category = "";
          if (security_system_identification.f == "F1") {
            if (security_system_identification.p == "P1") {
              this.security_system_category = "2";
            } else if (security_system_identification.p == "P2") {
              this.security_system_category = "3";
            }
          } else if (security_system_identification.f == "F2") {
            if (security_system_identification.p == "P1") {
              this.security_system_category = "3";
            } else if (security_system_identification.p == "P2") {
              this.security_system_category = "4";
            }
          }
        }
      },
      deep: true,
    },
  },
  validations: {
    machineSelected: {
      type: {
        required,
      },
      capacity: {},
      tension: {
        required,
      },
      manufacturer: {
        required,
      },
      manufactured_at: {},
      serie_number: {},
      sector: {
        required,
      },
      observations: {},
      machine_function: {
        required,
      },
    },
  },
};
</script>


<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/APR.scss";

.risk-color {
  color: hsl(0, 83%, 47%);
}

:deep(.multiselect) {
  min-height: 40px;
  width: 300px;
}

.big-radio {
  transform: scale(1.5);
  margin-right: 6px;
  cursor: pointer;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
